module.exports = __webpack_public_path__ + "img/content_image6.bf7f4904.png";